import BaseTableController from './base_table_controller';

// dp_id 412 — data_grid: { rows: [{ pollutant, air, water, soil }] }
export default class extends BaseTableController {
  static values = { pollutantOptions: Array };

  searchableFields = ['pollutant'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => ({
            pollutant: r.pollutant ?? '',
            air: r.air ?? null,
            water: r.water ?? null,
            soil: r.soil ?? null,
          }))
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { pollutant: '', air: null, water: null, soil: null };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    const field = el.dataset.field;
    this.rows[index][field] =
      el.type === 'number' ? (el.value === '' ? null : parseFloat(el.value)) : el.value;
    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    tr.appendChild(this.buildSelectCell(row, index, 'pollutant', this.pollutantOptionsValue));

    ['air', 'water', 'soil'].forEach((field) => {
      const td = document.createElement('td');
      const input = document.createElement('input');
      input.type = 'number';
      input.min = '0';
      input.step = '0.01';
      input.placeholder = '0.00';
      input.className = 'form-control w-100';
      input.dataset.rowIndex = index;
      input.dataset.field = field;
      input.dataset.action = `input->${this.identifier}#updateField`;
      if (row[field] !== null && row[field] !== undefined) input.value = row[field];
      td.appendChild(input);
      tr.appendChild(td);
    });

    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }
}
